const money = value => new Intl.NumberFormat(window.ModalTheme.locale, { style: 'currency', currency: window.ModalTheme.currency }).format(value / 100)

const initializedAnnouncements = new WeakSet()
function initAnnouncements(scope = document) {
  scope.querySelectorAll('[data-announcement-slider]').forEach(slider => {
    if (initializedAnnouncements.has(slider)) return
    initializedAnnouncements.add(slider)
    const slides = [...slider.querySelectorAll('[data-announcement-slide]')]
    if (slides.length < 2) return
    let current = 0
    window.setInterval(() => {
      slides[current].classList.remove('is-active')
      current = (current + 1) % slides.length
      slides[current].classList.add('is-active')
    }, Number(slider.dataset.interval) || 4000)
  })
}
initAnnouncements()
document.addEventListener('shopify:section:load', event => initAnnouncements(event.target))

const initializedCommunitySliders = new WeakSet()
function initCommunitySliders(scope = document) {
  scope.querySelectorAll('[data-community-slider]').forEach(slider => {
    if (initializedCommunitySliders.has(slider)) return
    initializedCommunitySliders.add(slider)
    const track = slider.querySelector('[data-community-track]')
    const interval = Math.max(2, Number(slider.dataset.interval) || 4) * 1000
    if (!track) return
    window.setInterval(() => {
      if (track.scrollWidth <= track.clientWidth) return
      const card = track.querySelector('.community-card')
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0
      const step = (card?.getBoundingClientRect().width || 285) + gap
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - step / 2
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' })
    }, interval)
  })
}
initCommunitySliders()
document.addEventListener('shopify:section:load', event => initCommunitySliders(event.target))

function updateVariant(root) {
  const data = root.querySelector('[data-variants]')
  if (!data) return
  const selected = []
  root.querySelectorAll('[data-option-index]:checked').forEach(input => { selected[Number(input.dataset.optionIndex)] = input.value })
  const variant = JSON.parse(data.textContent).find(item => item.options.every((value, index) => value === selected[index]))
  if (!variant) return
  const scope = root.closest('.product-template-grid') || root
  const id = root.querySelector('[data-variant-id]')
  const price = scope.querySelector('[data-variant-price]')
  const compare = scope.querySelector('[data-variant-compare]')
  const save = scope.querySelector('[data-variant-save]')
  const add = root.querySelector('.om-add-row button')
  if (id) id.value = variant.id
  if (price) price.textContent = money(variant.price)
  if (compare) compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''
  if (save) {
    const percent = variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0
    save.hidden = percent === 0
    if (percent) save.textContent = `${save.textContent.trim().split(/\s+/)[0]} ${percent}%`
  }
  if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'AGREGAR AL CARRITO' : 'AGOTADO' }
}

document.addEventListener('change', event => {
  const input = event.target.closest('[data-option-index]')
  if (!input) return
  const root = input.closest('[data-variant-product]')
  const fieldset = input.closest('fieldset')
  const label = fieldset && fieldset.querySelector('[data-option-label]')
  if (label) label.textContent = input.value
  updateVariant(root)
})

document.addEventListener('click', event => {
  const menu = event.target.closest('[data-menu-toggle]')
  if (menu) { document.querySelector('[data-menu]')?.classList.toggle('is-open'); return }

  const galleryThumb = event.target.closest('[data-gallery-thumb]')
  if (galleryThumb) {
    const gallery = galleryThumb.closest('.product-gallery')
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(item => item.classList.toggle('is-active', item === galleryThumb))
    gallery.querySelectorAll('[data-gallery-slide]').forEach(slide => slide.classList.toggle('is-active', slide.dataset.gallerySlide === galleryThumb.dataset.galleryThumb))
    return
  }

  const pressTab = event.target.closest('[data-press-tab]')
  if (pressTab) {
    const slider = pressTab.closest('[data-press-slider]')
    slider.querySelectorAll('[data-press-tab]').forEach(item => {
      const active = item === pressTab
      item.classList.toggle('active', active)
      item.setAttribute('aria-selected', active ? 'true' : 'false')
    })
    slider.querySelectorAll('[data-press-slide]').forEach(slide => {
      const active = slide.dataset.pressSlide === pressTab.dataset.pressTab
      slide.classList.toggle('active', active)
      slide.hidden = !active
    })
    return
  }

  const arrow = event.target.closest('[data-carousel-prev],[data-carousel-next]')
  if (arrow) {
    const track = arrow.closest('[data-carousel]').querySelector('[data-carousel-track]')
    const card = track.querySelector('.om-card')
    track.scrollBy({ left: (card?.getBoundingClientRect().width || 300) * (arrow.hasAttribute('data-carousel-prev') ? -1 : 1), behavior: 'smooth' })
    return
  }

  const tab = event.target.closest('[data-season-tab]')
  if (tab) {
    const root = tab.closest('[data-season-tabs]')
    root.querySelectorAll('[data-season-tab]').forEach(item => {
      const active = item === tab
      item.classList.toggle('is-active', active)
      item.setAttribute('aria-selected', active ? 'true' : 'false')
    })
    root.querySelectorAll('[data-season-panel]').forEach(panel => { panel.hidden = panel.dataset.seasonPanel !== tab.dataset.seasonTab })
    const link = root.querySelector('[data-season-link]')
    link.href = tab.dataset.seasonTab === 'women' ? link.dataset.womenUrl : link.dataset.menUrl
    return
  }

  const thumb = event.target.closest('[data-feature-thumb]')
  if (thumb) {
    const media = thumb.closest('.om-featured__media')
    media.querySelectorAll('[data-feature-thumb]').forEach(item => item.classList.toggle('is-active', item === thumb))
    media.querySelectorAll('[data-feature-slide]').forEach(slide => { slide.hidden = slide.dataset.featureSlide !== thumb.dataset.featureThumb })
    return
  }

  const quick = event.target.closest('[data-quick-open]')
  if (quick) {
    const template = document.getElementById(quick.dataset.quickOpen)
    const dialog = document.querySelector('[data-quick-dialog]')
    const content = dialog.querySelector('[data-quick-content]')
    content.replaceChildren(template.content.cloneNode(true))
    dialog.showModal()
    return
  }

  const close = event.target.closest('[data-quick-close]')
  if (close) { close.closest('dialog').close(); return }
  if (event.target.matches('[data-quick-dialog]')) event.target.close()
})
